// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-list{
    background-color: #555555;
    border-radius: 9px;
    display: flex;
    color: white;
    padding: 15px 20px;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
}

.card-list:hover {
    opacity: 0.5;
    cursor: pointer;
    transition: 0.5s;
}

.card-list-title{
    font-weight: 900;
    font-size: 0.9rem;
    text-align: center;
}

.card-list-name{
    font-size: 1.1rem;
    text-align: center;
}

.card-list-name-payment{
    font-size: 0.9rem;
    text-align: center;
}
.avatar-img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #a3a3a3;
    display: flex;
    justify-content: center;
}
.avatar-img img{
    width: 40px;
}
.card-list-img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: rgb(255, 255, 255);
}
.card-list-title-column{
    display: none;
}
@media (max-width:576px) {
    .card-list-title-column{
        display: block;
    }
    .card-list-name-big-info{
        text-align: left;
        justify-content: flex-start !important;
    }
    .card-list-title-sm{
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/componentsCss/ListCard.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,gBAAgB;QAChB,sCAAsC;IAC1C;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".card-list{\n    background-color: #555555;\n    border-radius: 9px;\n    display: flex;\n    color: white;\n    padding: 15px 20px;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 10px;\n}\n\n.card-list:hover {\n    opacity: 0.5;\n    cursor: pointer;\n    transition: 0.5s;\n}\n\n.card-list-title{\n    font-weight: 900;\n    font-size: 0.9rem;\n    text-align: center;\n}\n\n.card-list-name{\n    font-size: 1.1rem;\n    text-align: center;\n}\n\n.card-list-name-payment{\n    font-size: 0.9rem;\n    text-align: center;\n}\n.avatar-img{\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background-color: #a3a3a3;\n    display: flex;\n    justify-content: center;\n}\n.avatar-img img{\n    width: 40px;\n}\n.card-list-img{\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background-color: rgb(255, 255, 255);\n}\n.card-list-title-column{\n    display: none;\n}\n@media (max-width:576px) {\n    .card-list-title-column{\n        display: block;\n    }\n    .card-list-name-big-info{\n        text-align: left;\n        justify-content: flex-start !important;\n    }\n    .card-list-title-sm{\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
